"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserMultiSelectDropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SelectBoxWrapper = require("../../utils/components/SelectBoxWrapper");
var _useSelectedOption = require("../../utils/hooks/useSelectedOption");
var _multiSelectHelpers = require("../../utils/data/multiSelectHelpers");
var _common = require("../ProjectMemberDropdown/common");
var _ProjectMemberMultiSelectValueTag = require("../ProjectMemberDropdown/ProjectMemberMultiSelectValueTag");
var _alloyReactDropdown = require("@adsk/alloy-react-dropdown");
var _DropdownUtils = require("../../utils/components/DropdownUtils");
var _featureFlags = require("../../utils/featureFlags");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const UserMultiSelectDropdown = _ref => {
  let {
    shouldIncludeMemberFn,
    selectedOxygenIds,
    onChange,
    container,
    placeholder,
    ...props
  } = _ref;
  const {
    value: shouldUseNewDropdown
  } = (0, _featureFlags.useFeatureFlag)(_featureFlags.FeatureFlag.OutdatedComponentMigrationPhase1Batch2);
  const users = (0, _common.useProjectUsersAsOptions)({
    shouldIncludeMemberFn
  });
  // options should be memoized to avoid re-rendering the dropdown
  // the options are constant once defined and should not be changed in the context of a single app use
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const options = (0, _react.useMemo)(() => users, [shouldIncludeMemberFn]);
  const selectedOptions = (0, _useSelectedOption.useReferentialSelectedOptions)(selectedOxygenIds, options);
  const semanticIdentifier = "user-multi-select-dropdown";
  const NewDropdown = () => {
    const {
      controlProps,
      menuProps
    } = (0, _alloyReactDropdown.useMultiAutocomplete)({
      items: options,
      selectedItems: selectedOptions,
      onSelectedItemsChange: _ref2 => {
        let {
          selectedItems
        } = _ref2;
        onChange((0, _multiSelectHelpers.getMultiSelectChangePayload)(selectedItems));
      },
      id: semanticIdentifier
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.MultiAutocompleteTokenControl, _extends({}, controlProps, {
      placeholder: placeholder,
      style: {
        maxHeight: 340
      },
      renderItems: () => /*#__PURE__*/_react.default.createElement("div", {
        // needed to achieve styling parity with SelectBox
        style: {
          display: "flex",
          flexWrap: "wrap",
          overflowX: "hidden"
        }
      }, (selectedOptions || []).map(selectedItem => /*#__PURE__*/_react.default.createElement(_ProjectMemberMultiSelectValueTag.ProjectMemberMultiSelectValueTag, _extends({
        key: selectedItem.value
      }, selectedItem, {
        onRemove: value => {
          onChange(selectedOxygenIds.filter(oxygenId => oxygenId !== value));
        }
      })))),
      "data-testid": "".concat(semanticIdentifier, "-control")
    })), /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.MultiSelectMenu, _extends({}, menuProps, {
      "data-testid": "".concat(semanticIdentifier, "-menu"),
      renderFooter: () => (0, _DropdownUtils.DropdownFooter)({
        isClearable: true,
        handleChange: onChange,
        shouldDisplay: (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) > 0
      })
    }), menuProps.menuItems.length === 0 && controlProps.getInputProps() && /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.NoAutocompleteResults, {
      style: {}
    })));
  };
  const OldDropdown = () => /*#__PURE__*/_react.default.createElement(_SelectBoxWrapper.SelectBoxWrapper, _extends({
    multiple: true,
    showValueAsTags: true,
    valueTagRenderer: option => {
      return /*#__PURE__*/_react.default.createElement(_ProjectMemberMultiSelectValueTag.ProjectMemberMultiSelectValueTag, _extends({}, option, {
        onRemove: value => {
          onChange(selectedOxygenIds.filter(oxygenId => oxygenId !== value));
        }
      }));
    },
    placeholder: placeholder,
    clearable: true,
    searchable: true,
    options: options,
    value: selectedOptions,
    onChange: newSelectedOptions => {
      onChange((0, _multiSelectHelpers.getMultiSelectChangePayload)(newSelectedOptions));
    },
    container: container
  }, props));
  return shouldUseNewDropdown ? NewDropdown() : OldDropdown();
};
exports.UserMultiSelectDropdown = UserMultiSelectDropdown;
//# sourceMappingURL=UserMultiSelectDropdown.js.map